import i18n from '../../../lang/lang';

const mutations = {
  SET_LANG: (state, payload) => { console.log(app)
    i18n.locale = payload;
  },
  SET_LONG_LANG: (state, payload) => { console.log(app)
    i18n.long_locale = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/lang/mutations.js